import { getLocalUsers, setLocalUsers } from '@/services/localStorageService'

import mutations from './mutations'

export const persistentUsersPlugin = async (store) => {
  store.state.localUsers = getLocalUsers()
  store.subscribe(async ({ type, payload }, state) => {
    if (type === mutations.SET_LOCAL_USERS) {
      await setLocalUsers(payload)
    }
  })
}
